module.exports = __webpack_public_path__ + "static/metal-style-1-c6842476bd9046768fd18db70510b2f9.png";